export default __webpack_public_path__ + "static/media/rafael_pedicini-280.2d4e286f.jpg";